import React from 'react'
import './contribution-goal.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const ManageContributionGoal = ({ saveData, formData, disabled }) => {
    return (
        <div className='contribution-goal g-list-item form-section'>
            <h3>Contribution Settings</h3>
            <hr />
            <div className='field small'>
                <label><b>GOAL:</b>What currency goal should be set for this Contribution Item?</label>
                <div className='input-div'>
                    <ImageContainer
                        src='/images/icons/coin.png'
                        className='icon'
                    />
                    <input 
                        className='short-input' 
                        type='number' 
                        value={formData.opt_contributionGoal ?? ''} 
                        onChange={(e) => saveData('opt_contributionGoal', Number(e.target.value))} 
                    />
                </div>
            </div>
            <div className='g-space-2'></div>
            <div className='field small'>
                <label><b>MIN:</b>What is the minimum contribution allowed? (Leave blank to not require a minimum.)</label>
                <div className='input-div'>
                    <ImageContainer
                        src='/images/icons/coin.png'
                        className='icon'
                    />
                    <input 
                        className='short-input' 
                        type='number' 
                        value={formData.opt_contributionMin ?? ''} 
                        onChange={(e) => saveData('opt_contributionMin', Number(e.target.value))} 
                    />
                </div>
            </div>
            <div className='g-space-2'></div>
            <div className='field small'>
                <label><b>MAX:</b>What is the maximum contribution allowed? (Leave blank to not require a maximum.)</label>
                <div className='input-div'>
                    <ImageContainer
                        src='/images/icons/coin.png'
                        className='icon'
                    />
                    <input 
                        className='short-input' 
                        type='number' 
                        value={formData.opt_contributionMax ?? ''} 
                        onChange={(e) => saveData('opt_contributionMax', Number(e.target.value))} 
                    />
                </div>
            </div>
            <div className="g-space-2"></div>
            <div className='field small'>
                <label><b>LIMIT:</b>How many times can a player contribute? (Leave blank for no limit.)</label>
                <input 
                    className='short-input' 
                    type='number' 
                    value={formData.opt_contributionLimit ?? ''} 
                    onChange={(e) => saveData('opt_contributionLimit', Number(e.target.value))} 
                />
                
            </div>
            <div className="g-space-1"></div>
        </div>
    )
}

export default ManageContributionGoal